import { defineRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const inputAddonRecipe = defineRecipe({
  className: 'input-addon',
  base: {
    alignItems: 'center',
    alignSelf: 'stretch',
    background: 'background/secondary',
    borderBlockWidth: '1',
    borderColor: 'border/regular',
    borderStyle: 'solid',
    color: 'text/body',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    _readOnly: {
      background: 'background/disabled',
    },
    _disabled: {
      background: 'background/disabled',
      borderColor: 'border/disabled',
      color: 'text/disabled',
    },
  },
  variants: {
    position: {
      start: {
        borderInlineStartWidth: '1',
        borderStartStartRadius: '4',
        borderEndStartRadius: '4',
      },
      end: {
        borderInlineWidth: '1',
        borderStartEndRadius: '4',
        borderEndEndRadius: '4',
      },
    },
    size: {
      md: { paddingInline: rem(11), textStyle: 'body/md/regular' },
      lg: { paddingInline: rem(15), textStyle: 'body/lg/regular' },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default inputAddonRecipe;
